import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { DELETE_IMAGES } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { DeleteImagesDataActionTypes } from './types';
import { addImageDelete } from '../addImages/actions';
import fileApi from 'src/utils/api/fileApi';

export const loadDeleteImages =
  (
    id: number,
  ): ThunkAction<Promise<void>, State, null, DeleteImagesDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: DELETE_IMAGES + REQUEST });
    try {
      const payload = await fileApi.loadDeleteImages(id);
      dispatch({ type: DELETE_IMAGES + SUCCESS, payload });
      dispatch(addImageDelete(id));
    } catch (error) {
      dispatch({ type: DELETE_IMAGES + FAILURE, error });
    }
  };

export const deleteImageIdle = () => ({ type: DELETE_IMAGES + IDLE });
